export default __webpack_public_path__ + "static/media/42.a7cd758e.jpeg";